import React from 'react'

export const Title = ({ children }) => (
  <h1 className='py-2 font-sans text-3xl text-center text-bold text-gray-50 lg:text-6xl lg:py-3'>
    {children}
  </h1>
)
export const SubTitle = ({ children }) => (
  <p className='py-2 font-sans text-lg text-light text-gray-50 lg:text-2xl lg:py-3'>
    {children}
  </p>
)
export const MiddleTitle = ({ children }) => (
  <h3 className='py-2 font-sans text-2xl text-bold text-gray-50 lg:text-4xl lg:py-6'>
    {children}
  </h3>
)
export const Description = ({ children, white = true }) => (
  <p className={`text-xl lg:text-2xl ${white ? 'text-gray-300' : ''}`}>
    {children}
  </p>
)

export const Content = ({ children, white = true }) => (
  <p className={`text-lg lg:text-lg ${white ? 'text-gray-300' : ''}`}>
    {children}
  </p>
)

export const Information = ({ children, white = true }) => (
  <p className={`text-sm lg:text-sm ${white ? 'text-gray-300' : ''}`}>
    {children}
  </p>
)
export const InfoLink = ({ children, onClick, white = true }) => (
  <a
    onClick={onClick}
    className={`text-sm lg:text-sm cursor-pointer  ${
      white ? 'text-gray-300' : ''
    }`}
  >
    {children}
  </a>
)

export const Frame = ({ children }) => (
  <div className='flex flex-col items-center p-6 text-center lg:p-20'>
    {children}
  </div>
)
export const Markdown = ({ children }) => (
  <div className='flex flex-col p-6 text-center lg:p-20'>{children}</div>
)

export const Divider = () => <div className='w-20 h-1 bg-blue-600'></div>

export const DescBlock = ({ children }) => (
  <div className='flex flex-col items-start text-left lg:w-96'>{children}</div>
)
export const Block = () => <div className='h-2 lg:h-4' />
export const RowBlock = ({ children }) => (
  <div className='flex flex-col items-center w-full space-y-4 lg:flex-row lg:space-x-28'>
    {children}
  </div>
)
